import styled from 'styled-components';

import { ActionButtonVariants } from 'components/action-button';

import { StyledSignupButton as DefaultStyledSignupButton } from './signup-button.styled.default';

export * from './signup-button.styled.default';

export const StyledSignupButton = styled(DefaultStyledSignupButton)<{
  variant: ActionButtonVariants;
}>`
  ${Styles.headerMobile} {
    background-color: ${p =>
      p.variant === ActionButtonVariants.OUTLINE
        ? p.theme.primaryBackground
        : p.theme.token('background-button-primary-default')};
  }
`;
